import i18n from "@/i18n";
import { ContractsTypes } from "../../data/enums/contractsTypes";
import { ActionModel } from "../../models/ActionModel";
import { ContractModel } from "../../models/contracts/contractModel";
import { ContractsModel } from "../../models/contracts/contractsModel";
import { AppStore } from "../../store/modules/app";
import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { ContractsStore } from "../../store/modules/contracts";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

/**
 *  Класс для компоненты счета.
 */
export class BaseContractVue extends Vue {

  /** Идентификатор счета */
  @Prop() contractId!: number;

  /** отслеживаем идентификатор счета */
  @Watch("contractId", { immediate: true })
  contractIdChanged() {
    this.init();
    this.contractsStore.setSelected(this.contractId);
    this.isAliasEdit = false;
  }

  /** отслеживаем название счета */
  @Watch("getAlias", { immediate: true })
  aliasChange(newVal: string) {
    this.alias = newVal;
  }

  /** отслеживаем объект счета */
  @Watch('contract', { immediate: true })
  contractGetValue(val: ContractModel) {
    if (val) {
      this.isVisible = !val.Data.Hidden;
    }
  }

  /** признак отображения диалогового окна */
  dialog: boolean = false;

  /** контент диалогового окна */
  dialogContent: any = {};

  /** признак отображения диалогового окна (вклады) */
  forecastDialog: boolean = false;

  /** признак отображения диалогового окна (кредит) */
  scheduleDialog: boolean = false;

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**
 * Хранилище данных пользователя
 * @returns {PersonStore}
 */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище данных приложения
 * @returns {AppStore}
 */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }

  /**
 * Активный счет
 * @returns {ContractModel} - объект счета
 */
  get contract(): ContractModel {
    return this.contractsStore.contracts.getContract(this.contractId);
  }

  /**
 * Список счетов
 * @returns {ContractsModel} - модель хранящая все счета
 */
  get contracts(): ContractsModel {
    return this.contractsStore.contracts;
  }

  /**
 * Имя счеиа
 * @returns {string} - Имя счеиа
 */
  get getAlias(): string {
    return this.contract?.Data?.Alias;
  }

  // loading: boolean = true
  // /**Признак загрузки данных страницы */
  // get getLoading(): boolean {
  //   return this.contractsStore.loading
  // }

  /**
 * ризнак загрузки данных страницы
 * @returns {boolean} - Признак загрузки данных страницы
 */
  get loading(): boolean {
    return this.contractsStore.loading;
  }

  /** Алиас */
  alias: string = "";

  /**Правила проверки алиаса */
  aliasRules: Array<any> = [
    (value: any) => !!value || i18n.t("main.cards.errors.emptyAlias"), // проверка на пустоту
    (value: any) =>
      (value && value.length <= 30) ||
      i18n.t("main.cards.errors.maxLengthAlias") // проверка на максимальную длину алиаса
  ];

  /**Признак валидности алиаса */
  isAliasValid: boolean = true;
  /**Признак изменения алиаса на сервере */
  editAliasLoading: boolean = false;

  /**Признак изменения алиаса */
  isAliasEdit: boolean = false;

  statementMode: boolean = false;

  /**Признак отображения карты */
  isVisible: boolean = true;

  /**Признак ожидания с сервера изменения видимости */
  setVisibilityLoading: boolean = false;

  initSended: boolean = false;

  /**Список информации */
  get details(): Array<any> {
    let details: Array<any> = [];
    if (this.contract) {
      details = [
        {
          disabled: this.setVisibilityLoading,
          name: i18n.t("main.contracts.details.show"),
          textVal: (isVisible: boolean) => { 
            return isVisible
            ? i18n.t("main.contracts.details.showContract")
            : i18n.t("main.contracts.details.hideContract")
          },
          isAction: true,
          model: !this.contract.Data.Hidden,
          action: async (vis: boolean) => {
            await this.setVisibility();
          }
        }
      ];
      // {
      //   //Тарифный план
      //   name: i18n.t("main.contracts.details.tariff"),
      //   textVal: contract.Data.ContractTypeName,
      // },
      details.push({
        //Тип счёта
        name: i18n.t("main.contracts.details.type"),
        textVal: this.contract.ContractType
      });
      details.push({
        //Номер счета
        name: i18n.t("main.contracts.details.acntNum"),
        textVal: this.contract.Data.MainAccount
      });
      details.push({
        //Состояние
        name: i18n.t("main.contracts.details.state"),
        textVal: this.contract.IsOpen
          ? i18n.t("main.contracts.details.open")
          : i18n.t("main.contracts.details.close")
      });
      details.push({
        //Валюта счета
        name: i18n.t("main.contracts.details.currency"),
        textVal: this.contract.Currency
      });
      details.push({
        //Тип счёта
        name: i18n.t("main.contracts.details.type"),
        textVal: this.contract.ContractType
      });

      details.push({
        //Категория договора
        name: i18n.t("main.contracts.details.contractCategory"),
        textVal: this.contract.Data.ContractTypeName
      });
      if (this.contract.Data.Number) {
        details.push({
          //Номер договора
          name: i18n.t("main.contracts.details.contractNum"),
          textVal: this.contract.Data.Number
        });
      }
      if (this.contract.DateOpen) {
        details.push({
          //Дата открытия
          name: i18n.t("main.contracts.details.dateOpen"),
          textVal: this.contract.DateOpen
        });
      }
      if (this.contract.DateEnd) {
        details.push({
          //Дата завершения
          name: i18n.t("main.contracts.details.dateEnd"),
          textVal: this.contract.DateEnd
        });
      }
      if (!this.contract.IsOpen) {
        //Дата закрытия
        details.push({
          name: i18n.t("main.contracts.details.dateClose"),
          textVal: this.contract.DateClose
        });
      }

      if (this.contract.IsOpen) {
        if (
          this.contract.Data.ContractType !== ContractsTypes.CreditAccount &&
          this.contract.Data.ContractType !== ContractsTypes.TimeAccounts
        ) {
          //Списание
          details.push({
            name: i18n.t("main.contracts.details.canWithdraw"),
            textVal: this.contract.Data.CanWithdraw
              ? i18n.t("main.contracts.details.enable")
              : i18n.t("main.contracts.details.disable")
          });
          //Пополнение
          details.push({
            name: i18n.t("main.contracts.details.canDeposit"),
            textVal: this.contract.Data.CanDeposit
              ? i18n.t("main.contracts.details.enable")
              : i18n.t("main.contracts.details.disable")
          });
        } else if (
          this.contract.Data.ContractType === ContractsTypes.TimeAccounts
        ) {
          //Частичное снятие
          details.push({
            name: i18n.t("main.contracts.details.partCanWithdraw"),
            textVal: this.contract.Data.CanWithdraw
              ? i18n.t("main.contracts.details.enable")
              : i18n.t("main.contracts.details.disable")
          });
          //Ограничения снятия
          details.push({
            name: i18n.t("main.contracts.details.remCanWithdraw"),
            textVal: this.contract.Data.RemCanWithdraw
          });
          //Пополнение
          details.push({
            name: i18n.t("main.contracts.details.canDeposit"),
            textVal: this.contract.Data.CanDeposit
              ? i18n.t("main.contracts.details.enable")
              : i18n.t("main.contracts.details.disable")
          });
          //Ограничения пополнения
          details.push({
            name: i18n.t("main.contracts.details.remCanDeposit"),
            textVal: this.contract.Data.RemCanDeposit
          });
        }

        // Заблокировано на счете
        details.push({
          name: i18n.t("main.contracts.details.lockedSum"),
          textVal: `${this.contract.CalcLocked} ${this.contract.Currency}`
        });
        if (this.contract.Data.ArrestSum > 0) {
          // Арестованная сумма
          details.push({
            name: i18n.t("main.contracts.details.arrestSum"),
            textVal: `${this.contract.ArrestSum} ${this.contract.Currency}`
          });
        }
        if (
          this.contract.Data.MinDepositRest > 0 &&
          this.contract.Data.ContractType == ContractsTypes.DepositAccounts
        ) {
          // Из них неснижаемый остаток
          details.push({
            name: i18n.t("main.contracts.details.minDepositum"),
            textVal: `${this.contract.MinDepositRest} ${this.contract.Currency}`
          });
        }
        //Доступный остаток
        // details.push({
        //   name: i18n.t("main.contracts.details.disposableLimit"),
        //   textVal: `${contract.DisposableLimit} ${contract.Currency}`,
        // });

        if (
          this.contract.Data.ContractType == ContractsTypes.TimeAccounts &&
          this.contract.Data.FutureIncomeSum > 0
        ) {
          //Планируемый доход
          details.push({
            name: i18n.t("main.contracts.details.futureIncomeSum"),
            textVal: `${this.contract.FutureIncomeSum} ${this.contract.Currency}`
          });
        }
      }

      // Выводим остаток для Cрочных счетов и Счетов до востребования
      if (
        this.contract.Data.ContractType == ContractsTypes.DepositAccounts ||
        this.contract.Data.ContractType == ContractsTypes.TimeAccounts
      ) {
        if (!this.contract.IsUseCreditLimit) {
          // Остаток
          details.push({
            name: i18n.t("main.contracts.details.rest"),
            textVal: `${this.contract.Rest} ${this.contract.Currency}`
          });
        }
      }

      // Выводим доступный остаток для Текущих счетов и для Карточных счетов
      if (
        this.contract.Data.ContractType == ContractsTypes.CurrentAccount ||
        this.contract.Data.ContractType == ContractsTypes.CardAccount
      ) {
        // Доступный остаток
        details.push({
          name: i18n.t("main.contracts.details.disposableLimit"),
          textVal: `${this.contract.DisposableLimit} ${this.contract.Currency}`
        });
      }

      // Данные для карточного счёта
      if (this.contract.Data.ContractType == ContractsTypes.CardAccount) {
        if (this.contract.Data.PercentRate > 0) {
          // Процент на остаток
          details.push({
            name: i18n.t("main.contracts.details.percentRest"),
            textVal: `${this.contract.PercentRate}`
          });
        }
        // if (
        //   this.$store.getters.smsPackets &&
        //   this.$store.getters.smsPackets.find(
        //     (item: any) => item.Code === this.contract.Data.SmsPacketId
        //   ) &&
        //   this.contract.Data.SmsPacketId.trim() !== ""
        // ) {
        //   // Пакет SMS информирования
        //   details.push({
        //     name: i18n.t("main.contracts.details.smsPack"),
        //     textVal: `${
        //       this.$store.getters.smsPackets.find(
        //         (item: any) => item.Code === this.contract.Data.SmsPacketId
        //       ).Title
        //     }` //TODO: Заменить на текстовки смс пакетов
        //   });
        // }
        // Нет кредитного лимита
        if (!this.contract.IsUseCreditLimit) {
          // Остаток
          // details.push({
          //   name: i18n.t("main.contracts.details.rest"),
          //   textVal: `${contract.Rest} ${contract.Currency}`,
          // });
        } else {
          // Есть кредитный лимит (Счет кредитной карты или карта с овердрафтом)
          details.push({
            name: i18n.t("main.contracts.details.creditLimit"),
            textVal: `${this.contract.FullLimit} ${this.contract.Currency}`
          });
          //Использованный лимит
          details.push({
            name: i18n.t("main.contracts.details.usedLimit"),
            textVal: `${this.contract.UsedLimit} ${this.contract.Currency}`
          });
          //Собственные средства
          details.push({
            name: i18n.t("main.contracts.details.personalFunds"),
            textVal: `${this.contract.PersonalFunds} ${this.contract.Currency}`
          });
          //Кредитные средства
          details.push({
            name: i18n.t("main.contracts.details.creditFunds"),
            textVal: `${this.contract.CreditFunds} ${this.contract.Currency}`
          });
          if (this.contract.IsViewPercents) {
            //%% по сроку на
            details.push({
              name: i18n.t("main.contracts.details.captionPercOnMainSum", {
                percChargeDate: this.contract.PercChargeDate
              }),
              textVal: `${this.contract.PercOnMainSum} ${this.contract.Currency}`
            });
            //Просроченные %% на
            details.push({
              name: i18n.t("main.contracts.details.captionOutPercOnMainSum", {
                percChargeDate: this.contract.PercChargeDate
              }),
              textVal: `${this.contract.OutPercOnMainSum} ${this.contract.Currency}`
            });
          }

          //Льготный период.
          details.push({
            name: i18n.t("main.contracts.details.gracePayInfo"),
            textVal:
              this.contract.Data.FullLimit <= 0 ||
              this.contract.Data.GraceSum <= 0
                ? "-"
                : this.contract.Data.GraceOutstandingDate != null
                ? i18n.t("main.contracts.details.graceOutstandingText", {
                    graceOutstandingDate: this.contract.GraceOutstandingDate
                  })
                : i18n.t("main.contracts.details.graceEndText", {
                    graceEndDate: this.contract.GraceOutstandingDate
                  })
          });
          //Минимальный платёж
          details.push({
            name: i18n.t("main.contracts.details.minPayInfo"),
            textVal: this.contract.GetMinPayInfo()
          });
        }
      } else if (
        this.contract.Data.ContractType == ContractsTypes.DepositAccounts ||
        this.contract.Data.ContractType == ContractsTypes.TimeAccounts
      ) {
        if (this.contract.Data.IncomeSum > 0) {
          //Полученный доход
          details.push({
            name: i18n.t("main.contracts.details.incomeSum"),
            textVal: `${this.contract.IncomeSum} ${this.contract.Currency}`
          });
        }
        if (this.contract.IsOpen && this.contract.Data.PercentRate > 0) {
          // Процентная ставка
          details.push({
            name: i18n.t("main.contracts.details.percentRate"),
            textVal: `${this.contract.PercentRate}`
          });
        }
      } else if (
        this.contract.Data.ContractType == ContractsTypes.CreditAccount
      ) {
        if (this.contract.IsOpen && this.contract.Data.PercentRate > 0) {
          // Процентная ставка
          details.push({
            name: i18n.t("main.contracts.details.percentRate"),
            textVal: `${this.contract.PercentRate}`
          });
        }
        // Сумма кредита
        details.push({
          name: i18n.t("main.contracts.details.depositSum"),
          textVal: `${this.contract.DepositSum} ${this.contract.Currency}`
        });
        // Срок кредита (месяцев)
        details.push({
          name: i18n.t("main.contracts.details.depositPeriodMonth"),
          textVal: `${this.contract.DepositPeriodMonth}`
        });
        // Досрочное погашение
        details.push({
          name: i18n.t("main.contracts.details.canEarlyRepay"),
          textVal: this.contract.CanEarlyRepay
            ? i18n.t("main.contracts.details.enable")
            : i18n.t("main.contracts.details.disable")
        });
        // Cумма очередного платежа по основному долгу
        details.push({
          name: i18n.t("main.contracts.details.minPaySumMain"),
          textVal: `${this.contract.MinPaySumMain} ${this.contract.Currency}`
        });
        // Cумма очередного платежа по процентам
        details.push({
          name: i18n.t("main.contracts.details.minPaySumPercents"),
          textVal: `${this.contract.MinPaySumPercents} ${this.contract.Currency}`
        });
        // Остаток задолженности на текущую дату по процентам
        details.push({
          name: i18n.t("main.contracts.details.restAcntPercents"),
          textVal: `${this.contract.RestAcntPercents} ${this.contract.Currency}`
        });
      }

      if (this.contract.Data.ContractType == ContractsTypes.TimeAccounts) {
        // Срок (дней)
        details.push({
          name: i18n.t("main.contracts.details.depositPeriod"),
          textVal: `${this.contract.DepositPeriod}`
        });
        // Наличие капитализации
        details.push({
          name: i18n.t("main.contracts.details.isCapitalization"),
          textVal: this.contract.Data.Capitalization
            ? i18n.t("main.contracts.details.yes")
            : i18n.t("main.contracts.details.no")
        });
        // Выплата процентов
        details.push({
          name: i18n.t("main.contracts.details.payPercentsPeriod"),
          textVal: `${this.contract.PayPercentsPeriod}`
        });
      }
    }
    return details;
  }

  /**
 * Смс пакет счета
 * @returns {any} - Смс пакет счета
 */
  get personInfoSMS() {
    if (this.personStore.personInfo)
      return this.personStore.personInfo.Data.SmsPacketId;
    return null;
  }

  /**Список доступных операций */
  get actions(): Array<any> {
    const actions: Array<any> = [];
    if (this.contract) {
      if (
        this.contract.IsOpen &&
        this.contract.Data.CanDeposit &&
        this.configStore.apiData.OperationCodeOfToContract
      ) {
        /**Действие пополнения счета */
        actions.push({
          text: i18n.t("main.contracts.actions.fill"),
          iconClass: "fill-card-icon",
          action: () => {
            this.$router.push(
              `/operation/0/${this.configStore.apiData.OperationCodeOfToContract}?contractTo=${this.contract.Data.ReferenceId}`
            );
          }
        });
      }
      if (this.contract.IsOpen && this.contract.Data.CanWithdraw) {
        actions.push({
          /**Действие оплаты со счета */
          text: i18n.t("main.contracts.actions.pay"),
          iconClass: "pay-icon",
          action: () => {
            if (this.contract.Data.ContractType === 2 || this.contract.Data.ContractType === 1) 
                this.$router.push(`/operation/0/${this.configStore.apiData.OperationCodeOfToContract}?contract=${this.contract.Data.ReferenceId}`)
            else
                this.$router.push(`/payments?contract=${this.contract.Data.ReferenceId}`);
          }
        });
      }
      if (
        this.configStore.apiData.OperationCodeOfChangeSmsPacket &&
        !this.personInfoSMS &&
        this.contract.Data.ContractType === 4
      ) {
        actions.push({
          text: i18n.t("main.contracts.actions.smsPacket"),
          iconClass: "block-card-icon",
          action: () => {
            this.dialogContent = new Object({
              vueName: "ContractSmsModal",
              params: {
                contractId: this.contract.Data.ReferenceId
              }
            });
            this.dialog = true;
          }
        });
      }
      if (this.contract.Data.ContractType === 2) {
        /** Действие запроса графика для Вкладов */
        actions.push({
          text: i18n.t("main.contracts.actions.forecast", {
            inCome: `${this.contract.Data.FutureIncomeSum} ${this.contract.Currency}`
          }),
          iconClass: "statement-icon",
          action: async () => {
            this.forecastDialog = true;
            if (this.contract.DepositForeCast.length === 0) {
              await this.contractsStore.fetchForeCastDeposit(
                this.contract.Data.Id
              );
            }
          }
        });
      }
      if (this.contract.Data.ContractType === 5) {
        /** Действие запроса графика для кредитов */
        actions.push({
          text: i18n.t("main.contracts.actions.schedule"),
          iconClass: "statement-icon",
          action: async () => {
            this.scheduleDialog = true;
            if (!this.contract.CreditSchedule) {
              await this.contractsStore.fetchScheduleCredit(
                this.contract.Data.Id
              );
            }
          }
        });
      }
      /**Действие запроса выписки по счету*/
      actions.push({
        text: i18n.t("main.contracts.actions.statement"),
        iconClass: "statement-icon",
        action: () => {
          this.$router.push(`/statement/${this.contract.Data.Id}/0`);
        }
      });
      /**Действие запроса реквизитов счета */
      actions.push({
        text: i18n.t("main.contracts.actions.requisits"),
        iconClass: "requisits-icon",
        action: () => {
          this.showRequisites();
        }
      });
    }
    return actions;
  }

  /**Признак отображения окна реквизитов */
  requisitesDialog: boolean = false;

  /**Показать окно реквизитов */
  showRequisites() {
    this.requisitesDialog = true;
  }

  /**
 * Заголовок таб бара
 * @returns {string} - заголовок
 */
  get getTabtitle(): string {
    if (this.contract) {
      if (
        this.contract.Data.ContractType === 3 ||
        this.contract.Data.ContractType === 4
      )
        return this.$i18n.t("main.contracts.details.about").toString();
      else if (
        this.contract.Data.ContractType === 1 ||
        this.contract.Data.ContractType === 2
      )
        return this.$i18n.t("main.contracts.details.aboutDepo").toString();
      return this.$i18n.t("main.contracts.details.aboutCredit").toString();
    }
    return this.$i18n.t("main.contracts.details.about").toString();
  }

  /** Метод устанавливающий валидность алиаса */
  get setAliasValid(): (isError: boolean) => void {
    return (isError: boolean) => {
      this.isAliasValid = !isError;
    };
  }

  /** Установка видимости счета */
  async setVisibility() {
    this.setVisibilityLoading = true;
    let model: ActionModel = new ActionModel();
    model.Data["contractId"] = this.contract.Data.Id;
    model.Data["hidden"] = this.contract.Data.Hidden;
    model = (await this.contractsStore.setContractVisibility(
      {
        actionModel: model,
        respCode: this.configStore.apiData.OperationCodeOfSetContractVisibility
      }
    )) as ActionModel;
    if (model.IsError) this.isVisible = !this.isVisible; //в случае ошибки откатываем изменения
    this.setVisibilityLoading = false;
  }

  /**Изменение псевдонима счета */
  get editAlias(): () => Promise<void> {
    return async () => {
      const oldAlias = this.contract.Data.Alias.trim();
      if (!this.isAliasValid) {
        this.alias = oldAlias;
        return;
      }

      if (this.alias == oldAlias) return;

      this.isAliasEdit = false;
      this.editAliasLoading = true;
      let model: ActionModel = new ActionModel();
      model.Data["contractId"] = this.contract.Data.Id;
      model.Data["alias"] = this.alias;
      model = (await this.contractsStore.editContractAlias(
        model
      )) as ActionModel;
      if (model.IsError) this.alias = oldAlias; //в случае ошибки откатываем изменение

      this.editAliasLoading = false;
    };
  }

  /**Инициализация страницы */
  async init(): Promise<void> {
    if (this.initSended)
      return;
    if (this.contractId) {
      this.initSended = true;
      this.contractsStore.updateContract(this.contractId);
      await this.contractsStore.fetchSmsPackets(this.contractId);
      this.initSended = false;
    }
  }
}
